import { create } from 'zustand'
import { createSelectors } from '~/shared/lib/zustand-utils'

interface FiltersStore {
  dateReceivedFilterType: 'today' | 'last7days' | 'custom' | null
  setDateReceivedFilterType: (
    dateReceivedFilterType: 'today' | 'last7days' | 'custom' | null,
  ) => void
}

const filtersStore = createSelectors(
  create<FiltersStore>((set) => ({
    dateReceivedFilterType: null,
    setDateReceivedFilterType: (dateReceivedFilterType: 'today' | 'last7days' | 'custom' | null) =>
      set({ dateReceivedFilterType }),
  })),
)

export const useFiltersStoreSelectors = () => {
  const dateReceivedFilterType = filtersStore.use.dateReceivedFilterType()
  const setDateReceivedFilterType = filtersStore.use.setDateReceivedFilterType()
  return { dateReceivedFilterType, setDateReceivedFilterType }
}
